<template>
    <div :class="switchClass" class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate">
        <div class="bootstrap-switch-container" @click="triggerToggle()">
            <span :class="`bootstrap-switch-${type}`" class="bootstrap-switch-handle-on ">
                <slot name="on">
                    {{ onText }}
                </slot>
            </span>
            <span class="bootstrap-switch-label"></span>
            <span :class="`bootstrap-switch-${type}`" class="bootstrap-switch-handle-off">
                <slot name="off">
                    {{ offText }}
                </slot>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PSwitch',
    props: {
        value: {
            type: [Array, Boolean],
            description: 'Switch value'
        },
        disabled: {
            type: [Boolean, String],
            description: 'Whether switch is disabled'
        },
        onText: {
            type: String,
            description: 'switch on text'
        },
        offText: {
            type: String,
            description: 'switch off text'
        },
        type: {
            type: String,
            description: 'Switch type (primary|info|danger|default|warning|success)',
            default: 'default'
        }
    },
    computed: {
        switchClass() {
            let base = 'bootstrap-switch-'
            let state = this.model ? 'on' : 'off'
            return base + state
        },
        model: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        triggerToggle() {
            this.model = !this.model
        }
    }
}
</script>
<style></style>
